document.addEventListener('alpine:init', () => {
    Alpine.data('SubNavigation', () => ({
        activeSection: '',
        
        scrollToTarget(targetId) {
            if (!targetId) {
                console.error('No target ID provided');
                return;
            }

            const target = document.getElementById(targetId);
            if (!target) {
                console.error(`Element with ID ${targetId} not found`);
                return;
            }

            pegasus.scroll(target, -100, 'scrollTo');
        },

        init() {
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            };

            const observerCallback = (entries) => {
                entries.forEach(entry => {
                    const targetId = entry.target.getAttribute('id');
                    if (targetId && entry.isIntersecting) {
                        this.activeSection = targetId;
                    }
                });
            };

            const observer = new IntersectionObserver(observerCallback, observerOptions);

            document.querySelectorAll('section[id]').forEach(section => {
                observer.observe(section);
            });
        }
    }));
});
